module.exports = __webpack_public_path__ + "img/logo.d89ab802.png";